import {DEFAULT_ARRAY_INDEX, DISCOUNT_COOKIE_KEY} from '../const';

export class PriceInfo {
    constructor(priceInfo) {
        this._priceInfo = priceInfo;
    }

    getRestoreStatus() {
        return this._priceInfo['isRestored'];
    }

    getFillStatus() {
        return this._priceInfo['isFilled'];
    }

    getRatePlan() {
        return this._priceInfo['ratePlan'] ? this._priceInfo['ratePlan'] : null;
    }

    getRatePlaneCode() {
        const ratePlan = this.getRatePlan();

        return ratePlan ? ratePlan['code'] : '';
    }

    getData() {
        return this._priceInfo['date'];
    }

    getMinLos() {
        return this._priceInfo['minLos'];
    }

    getRatePlaneName() {
        const ratePlan = this.getRatePlan();

        if (ratePlan) {
            const ratePlanNames = ratePlan['names'];
            const availableLangs = Object.keys(ratePlanNames);

            return ratePlanNames[MODULE_PRICE_LOAD_LANG]
                ? ratePlanNames[MODULE_PRICE_LOAD_LANG]
                : ratePlanNames[availableLangs[DEFAULT_ARRAY_INDEX]];
        }

        return '';
    }

    getPrice() {
        if (this._shouldShowDiscountPrice()) {
            const discountPrices = this._getDiscountPrices();
            if (discountPrices) {
                return Object.values(discountPrices)[DEFAULT_ARRAY_INDEX];
            }
        }

        return Object.values(this._getPrices())[DEFAULT_ARRAY_INDEX];
    }

    getPriceByCurrency(currency) {
        if (this._shouldShowDiscountPrice()) {
            const discountPrice = this._getDiscountPrices();
            if (discountPrice) {
                return discountPrice[currency] ? discountPrice[currency] : '';
            }
        }

        const price = this._getPrices();

        if (price) {
            return price[currency]
                ? price[currency]
                : '';
        }

        return '';
    }

    isEmpty() {
        return Boolean(this._priceInfo);
    }

    _getPrices() {
        return this._priceInfo['price'];
    }

    _getDiscountPrices() {
        return this._priceInfo['discountPrice'];
    }

    _getExtraPlacementPrices() {
        return this._priceInfo['extraPlacementPrice'];
    }

    getExtraPlacementPriceByCurrency(currency) {
        const extraPlacementPrice = this._getExtraPlacementPrices();

        if (extraPlacementPrice) {
            return extraPlacementPrice[currency] ? extraPlacementPrice[currency] : '';
        }

        return '';
    }

    _shouldShowDiscountPrice() {
        const cookieValue = this._getCookie(DISCOUNT_COOKIE_KEY);
        return cookieValue === 'true';
    }

    _getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        return null;
    }
}
